import pluralize from 'pluralize';

export const dataLagDisplayValue = (
  value: boolean | number | null | undefined
): string => {
  if (!value || typeof value === 'boolean') {
    return value ? 'Lag data 1 year' : 'No lag';
  }

  if (value % 12 === 0) {
    const years = value / 12;
    return `Lag data ${years} ${pluralize('year', years)}`;
  } else {
    return `Lag data ${value} ${pluralize('month', value)}`;
  }
};
